"use client";

import { useTranslation } from "react-i18next";

export type KnowledgeScopeSelectOption =
  | string
  | { value: string; label: string };

export interface KnowledgeScopeSelectProps {
  options: readonly KnowledgeScopeSelectOption[];
  value: string | null;
  onChange: (value: string | null) => void;
  disabled?: boolean;
  allLabel?: string;
}

export function KnowledgeScopeSelect({
  options,
  value,
  onChange,
  disabled = false,
  allLabel,
}: KnowledgeScopeSelectProps) {
  const { t } = useTranslation();

  return (
    <label className="knowledge-scope-select inline-flex h-8 w-48 shrink-0 items-center gap-1.5 rounded-lg border border-[var(--border)] bg-[var(--card)] px-2 text-[13.5px] text-[var(--foreground)] focus-within:outline focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-[var(--ring)]">
      <span className="shrink-0 font-semibold text-[var(--muted-foreground)]">
        {t("Knowledge")}
      </span>
      <select
        aria-label={t("Knowledge")}
        className="min-w-0 flex-1 cursor-pointer truncate bg-transparent font-semibold outline-none disabled:cursor-default disabled:opacity-55"
        disabled={disabled}
        value={value ?? ""}
        onChange={(event) => onChange(event.target.value || null)}
      >
        <option value="">{allLabel ?? t("All")}</option>
        {options.map((option) => {
          const { value: optionValue, label } =
            typeof option === "string"
              ? { value: option, label: option }
              : option;
          return (
            <option key={optionValue} value={optionValue}>
              {label}
            </option>
          );
        })}
      </select>
    </label>
  );
}
